import addError from '../../../utils/error.jsx';

export function request() {
    return {
        type: 'STAFF_GET_REQUEST'
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'STAFF_GET_ERROR',
        errors
    };
}

export function finish(staff) {
    return {
        type: 'STAFF_GET_FINISH',
        staff
    };
}
